export const allergyOptions = [
  { label: "Peanuts", value: "peanuts" },
  { label: "Shellfish", value: "shellfish" },
  { label: "Penicillin", value: "penicillin" },
  { label: "Latex", value: "latex" },
  { label: "Dust Mites", value: "dust_mites" },
  { label: "Pollen", value: "pollen" },
  { label: "Eggs", value: "eggs" },
  { label: "Milk", value: "milk" },
  { label: "Soy", value: "soy" },
  { label: "Fish", value: "fish" },
];
